import { render, staticRenderFns } from "./devicesList.vue?vue&type=template&id=480b7e82&"
import script from "./devicesList.vue?vue&type=script&lang=js&"
export * from "./devicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports